<script setup lang="ts">

import { useI18n } from "vue-i18n";

import MissionTile from "@/components/tileContent/MissionTile.vue";

interface Props {
    // biome-ignore lint/suspicious/noExplicitAny: Init Biome
    interimMissions?: any;
}

defineProps<Props>();
const { t } = useI18n();
</script>

<template>
    <div class="InterimMissions">
        <template v-if="interimMissions.lastClientMissions?.length">
            <div class="subtitle">{{t('page.client.lastMissions')}}</div>
            <PerfectScrollbar class="tiles">
                <MissionTile v-for="(mission, index) in interimMissions.lastClientMissions"
                            :mission="mission"
                            :key="index"/>
            </PerfectScrollbar>
        </template>
        <template v-if="interimMissions.lastMissions?.length">
            <div class="subtitle">{{t('page.client.lastClients')}}</div>
            <PerfectScrollbar class="tiles">
                <MissionTile v-for="(mission, index) in interimMissions.lastMissions"
                            :mission="mission"
                            :key="index"/>
            </PerfectScrollbar>
        </template>
    </div>
</template>

<style lang="scss">
.InterimMissions {
    .subtitle {
        margin-bottom: $padding;
    }

    .tiles {
        display: flex;
        flex-wrap: unset;
        overflow: auto;
        margin-bottom: $padding;
        .Tile {
            margin-bottom: 0 !important;
        }
    }
    .position {
        padding: 0 8px;
    }

    .section {
        width: 100% !important;
        &.bottom {
            display: block !important;
        }
    }
}
</style>
